document.addEventListener('DOMContentLoaded', function() {
  // 1) Find the Add-to-Bag button & its form
  var button = document.querySelector('button.product-form__submit');
  if (!button) return console.warn('[DP] button not found');
  var form = button.closest('form');
  if (!form)   return console.warn('[DP] form not found');

  // 2) Inject the dynamic-price span (gap to icon is set here)
  var priceSpan = document.createElement('span');
  priceSpan.className = 'dynamic-price';
  priceSpan.style.marginLeft = '0.2em'; // reduced gap between icon and price
  priceSpan.style.fontSize = '0.9em';
  button.appendChild(priceSpan);

  // 3) Clone and style your header SVG inline, with tighter spacing
  var headerSvg = document.querySelector('#cart-icon-bubble svg');
  if (headerSvg) {
    console.log('[DP] cloning header SVG with tighter spacing');
    var svgClone = headerSvg.cloneNode(true);

    // Remove any existing fill/stroke attributes
    svgClone.removeAttribute('fill');
    svgClone.removeAttribute('stroke');

    // Force a larger size if you like (keep at 1.5em or adjust)
    svgClone.setAttribute('width',  '2em');
    svgClone.setAttribute('height', '2em');
    svgClone.style.display       = 'inline-block';
    svgClone.style.verticalAlign = 'middle';

    // For every shape inside, fill it white AND add a white stroke
    svgClone.querySelectorAll('*').forEach(function(el) {
      if (el.tagName.toLowerCase() === 'path' || el.tagName.toLowerCase() === 'circle' || el.tagName.toLowerCase() === 'rect') {
        el.setAttribute('fill',         '#fff');
        el.setAttribute('stroke',       '#fff');
        el.setAttribute('stroke-width', '0.04em');
        el.setAttribute('stroke-linejoin','round');
        el.setAttribute('stroke-linecap', 'round');
      }
    });

    // Turn every shape inside it white (kept from your original)
    svgClone.querySelectorAll('*').forEach(function(el) {
      if (el.hasAttribute('fill'))   el.setAttribute('fill',   '#fff');
      if (el.hasAttribute('stroke')) el.setAttribute('stroke', '#fff');
    });

    // Wrap it for spacing: only 0.1em on each side
    var iconWrapper = document.createElement('span');
    iconWrapper.className = 'btn-icon';
    iconWrapper.style.display       = 'inline-flex';
    iconWrapper.style.verticalAlign = 'middle';
    iconWrapper.style.margin        = '0 0.1em';
    iconWrapper.appendChild(svgClone);

    // Insert it *before* the price span
    button.insertBefore(iconWrapper, priceSpan);
  } else {
    console.warn('[DP] header SVG not found at #cart-icon-bubble svg');
  }

  // 4) Pre-fetch product JSON
  var m = window.location.pathname.match(/\/products\/([^\/]+)/);
  if (!m) return console.warn('[DP] no product handle in URL');
  var productPromise = fetch('/products/' + m[1] + '.js')
    .then(function(res) { return res.json(); })
    .catch(function(err) {
      console.error('[DP] fetch error', err);
      return null;
    });

  // ===== NEW: helpers to read the displayed price (includes YMQ add-ons) =====
  function cleanText(t) {
    return (t || '').replace(/\s+/g, ' ').trim();
  }

  // Broad selector that usually hits Dawn/modern themes
  function findPriceRoot() {
    return (
      document.querySelector('[id^="price-"]') ||
      document.querySelector('.product__info-container .price') ||
      document.querySelector('.product__info-container [class*="price"]') ||
      document.querySelector('.price') ||
      null
    );
  }

  function getDisplayedUnitPriceText() {
    var root = findPriceRoot();
    if (!root) return '';

    var candidates = [
      '.price__sale .price-item--sale',
      '.price__sale .price-item--last',
      '.price__regular .price-item--regular',
      '.price-item--sale',
      '.price-item--regular',
      '.price-item'
    ];

    for (var i = 0; i < candidates.length; i++) {
      var el = root.querySelector(candidates[i]);
      var txt = cleanText(el && el.textContent);
      if (txt) return txt;
    }
    return cleanText(root.textContent);
  }

  // Parse "£9.24" / "€9,24" / "US$9.24" into cents (best effort)
  function moneyTextToCents(text) {
    if (!text) return null;

    // Keep digits/separators only
    var s = text.replace(/[^\d.,-]/g, '').trim();
    if (!s) return null;

    // Decide decimal separator by last occurrence
    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');

    var decimalSep = null;
    if (lastDot > -1 || lastComma > -1) {
      decimalSep = (lastDot > lastComma) ? '.' : ',';
    }

    // Remove thousands separators, normalize decimal to "."
    if (decimalSep === ',') {
      s = s.replace(/\./g, '').replace(',', '.');
    } else if (decimalSep === '.') {
      s = s.replace(/,/g, '');
    }

    var n = Number(s);
    if (!isFinite(n)) return null;

    return Math.round(n * 100);
  }
  // ========================================================================

  // 5) Polling loop for dynamic price + 20% off at qty ≥3
  var lastVid, lastQty, lastUnitCents;

  function updatePrice() {
    Promise.resolve(productPromise).then(function(product) {
      if (!product) return;

      var vid = Number(form.querySelector('input[name="id"]').value);
      var qty = parseInt(new FormData(form).get('quantity'), 10) || 1;

      // NEW: also include displayed unit price in the "did anything change?" check
      var displayedText = getDisplayedUnitPriceText();
      var unitCentsFromDisplay = moneyTextToCents(displayedText);

      if (vid === lastVid && qty === lastQty && unitCentsFromDisplay === lastUnitCents) return;
      lastVid = vid; lastQty = qty; lastUnitCents = unitCentsFromDisplay;

      var variant = product.variants.find(function(v) { return v.id === vid; });
      if (!variant) {
        console.warn('[DP] variant not found for id', vid);
        return;
      }

      // NEW: Use displayed price if we can parse it (includes YMQ tassel),
      // otherwise fall back to base variant price.
      var unitPriceCents = unitCentsFromDisplay;
      if (unitPriceCents == null || !isFinite(unitPriceCents) || unitPriceCents <= 0) {
        unitPriceCents = variant.price; // cents
      }

      var subtotal = unitPriceCents * qty;
      if (qty >= 3) subtotal = Math.round(subtotal * 0.8); // apply 20% off when 3+

      // Format using Shopify.formatMoney with theme’s money_format
      var formatted;
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        var fmt = window.moneyFormat || window.Shopify.money_format || window.Shopify.moneyFormat || '${{amount}}';
        formatted = window.Shopify.formatMoney(subtotal, fmt);
      } else {
        // fallback: use Intl.NumberFormat based on shopCurrency
        try {
          var currency = window.shopCurrency || (Shopify.currency && Shopify.currency.active) || 'GBP';
          formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(subtotal/100);
        } catch (e) {
          formatted = (subtotal/100).toFixed(2);
        }
      }

      // General strip currency prefixes like 'US', 'CA', 'AUD' before symbol
      formatted = formatted.replace(/^[A-Z]{1,3}\s*/, '');

      priceSpan.textContent = ' ' + formatted;
      button.disabled = !variant.available;
      button.classList.toggle('btn--disabled', !variant.available);
    });
  }

  updatePrice();
  setInterval(updatePrice, 300);
});
